import React from 'react';
import logo from '../../../assets/logos/Logo.svg';
import './ServiceUnavailable.css';

const ServiceUnavailable = () => {
  return (
    <div className="service-unavailable" role="alert">
      <img className="service-unavailable__logo" src={logo} alt="VBS" width="67" height="32" />
      <div className="service-unavailable__content">
        <h1 className="service-unavailable__title">Oops, something went wrong</h1>
        <p className="service-unavailable__message">
          We&apos;re having trouble connecting right now. Please try again in a few moments.
        </p>
      </div>
    </div>
  );
};

export default ServiceUnavailable;
